import React, { useCallback, useEffect, useState } from "react";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import ParamListGen from "Services/ParamListGen";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import api from "http";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import CustomInput from "Common/CustomInput";
import { TODAY_DATE } from 'Common/Constants';
import Pagination from "Common/CusomReactGrid/Pagination";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import FormatMomentDate from "Utils/FormatMomentDate";

const ClaimTimeLinePopup = ({ onClose, Id, APi, History, objectData, keyName, createdDate, disableDraggable }) => {
  const UNIQUE_ID = "ClaimTimeLinePopup"
  const [loader, setLoader] = useState(false);
  const [historyModel, setHistoryModel] = useState({
    fromDate: FormatMomentDate(createdDate,"YYYY-MM-DD") ,
    toDate: TODAY_DATE,
  });
  const [formInputs, setFormInputs] = useState(historyModel);
  const [state, setState] = useState({
    History,
    pagination: {
      pageNo: 1,
      perPage: 20,
      totalCount: 0,
    }
  });
  const HandleSearch = useCallback(async (pageNo = 1, perPage = 10) => {
    try {
      setLoader(true)
      const payload = {
        param_list: ParamListGen({ ...historyModel, [keyName]: Id }),
        practiceId: 0,
        perPage: perPage,
        pageNo: pageNo,
        totalPages: 0,
        totalCount: 0,
        isExportCall: false,
      };
      const response = await api.post(`${process.env.REACT_APP_TC_PMS}${APi}`, payload);
      setState((prev) => ({
        ...prev,
        History: response.data.dataModel,
        pagination: {
          ...prev.pagination,
          pageNo: pageNo,
          perPage: perPage,
          totalCount: response.data?.dataModel?.totalRecord || 0, // Make sure your API returns totalCount
        }
      }));

    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoader(false);
    }
  }, [historyModel, Id]);

  useEffect(() => {
    if (Id) {
      HandleSearch(1, state.pagination.perPage);
    }
  }, [Id, state.pagination.perPage, HandleSearch]);


  const handlePageChange = (pageNo) => {
    HandleSearch(pageNo, state.pagination.perPage);
  }

  const handlePerRowsChange = (perPage, pageNo) => {
    HandleSearch(pageNo, perPage);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInputs(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSearchButtonClick = () => {
    setHistoryModel(formInputs);
    HandleSearch(1, state.pagination.perPage);
  };

  return (
    <ReactPortal wrapperId={UNIQUE_ID}>
      {loader && <FullPageLoader allowFullScreen />}
      <div
        data-te-modal-init
        className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-modal="true"
        data-te-open="true"
      >
        <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
          <div
            data-te-modal-dialog-ref
            className="relative w-[1140px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
          >
            {/* Header */}
            <div
              id={UNIQUE_ID}
              className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
            >
              Timeline
              <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                <img src="/img/crossblack.svg" alt="cross" />
              </button>
            </div>
            <div className="p-5">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-3">
                  <CustomInput name={"fromDate"} type="date" value={formInputs.fromDate} onChange={handleChange} label={"Date From"} />
                </div>
                <div className="col-span-12 md:col-span-3">
                  <CustomInput name={"toDate"} type="date" value={formInputs.toDate} onChange={handleChange} label={"Date To"} />
                </div>
      
                <div className="flex items-end justify-end col-span-12 md:col-span-6">
                  <CustomButtonNew label={"Search"} onClick={handleSearchButtonClick} />
                </div>
              </div>
            </div>

            <div className="px-5 overflow-y-auto overflow-x-hidden max-h-[50vh]">
                <div className="grid grid-cols-12 ">
                  <table className="w-full col-span-12 table-fixed">
                    <thead className="w-full ">
                      <tr>
                        <th className="p-1 px-2 text-center bg-gray-100 border border-gray-400 w-[100px]">--</th>
                        <th className="p-1 px-2 bg-gray-100 border border-gray-400 w-[120px]">Date</th>
                        <th className="p-1 px-2 bg-gray-100 border border-gray-400 w-[150px]">User Name</th>
                        <th className="p-1 px-2 bg-gray-100 border border-gray-400 ">Action Detail</th>
                      </tr>
                    </thead>
                    <tbody>
                      {objectData.map((data) => (
                        state.History[data.object]?.map((row, index) => (
                          <tr key={index} className="text-center">
                            {index === 0 && (
                              <td
                                className="font-bold bg-gray-100 border-[1px] border-gray-400 shadow-sm text-center p-2 w-[100px]"
                                rowSpan={state.History[data.object].length}
                              >
                                {data.type}
                              </td>
                            )}
                            <td className={`p-2 ${state.History[data.object].length - 1 === index ? 'border-b-[1px] border-gray-400 border border-r-gray-100' : 'border'} text-sm w-[120px]`}>{row.logDate}</td>
                            <td className={`p-2 ${state.History[data.object].length - 1 === index ? 'border-b-[1px] border-gray-400 border border-r-gray-100' : 'border'} text-sm w-[150px]`}>{row.userName}</td>
                            <td className={`p-2 ${state.History[data.object].length - 1 === index ? 'border-b-[1px] border-gray-400 border w-[700px] border-r-gray-100' : 'border w-[700px]'} text-left text-sm max-w-[680px] border-r-gray-400`}>
                              <pre className="whitespace-pre-wrap break-words">{row.actionDetail || "---"}</pre>
                            </td>
                          </tr>
                        ))
                      ))}
                    </tbody>
                  </table>
                </div>
            </div>
            <Pagination
              pagination={state.pagination}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              totalRows={state.pagination.totalCount} // Ensure this is the total count of all records
            />
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};

export default ClaimTimeLinePopup;
